module.exports = __webpack_public_path__ + "static/quest-creators-license-and-resource-72932d343a6d2f0af7a5804d9c0b2b46.pdf";